import React from 'react';

const SvgConfirmEmail = props => (
  <svg
    id="prefix__img_confirm_email"
    width={props.width || 323}
    height={props.height || 214}
    viewBox="0 0 323 214"
    {...props}
  >
    <defs>
      <style>
        {
          '.confirm_email_svg__cls-1{fill:#69d6d6;opacity:.1}.confirm_email_svg__cls-2{fill:none;stroke:#63d8f1;stroke-miterlimit:10;stroke-width:5px}.confirm_email_svg__cls-3{fill:#63d8f1}.confirm_email_svg__cls-4{fill:#104eb2}'
        }
      </style>
    </defs>
    <g
      id="confirm_email_svg__Grupo_349"
      data-name="Grupo 349"
      transform="translate(0 2.5)"
    >
      <path
        id="confirm_email_svg__Trazado_186"
        data-name="Trazado 186"
        className="confirm_email_svg__cls-1"
        d="M28.216 106.926H12.951A13.014 13.014 0 010 93.938v-2.687A13.006 13.006 0 0112.951 78.3h15.227a12.982 12.982 0 0112.951 12.951v2.687a12.958 12.958 0 01-12.913 12.988z"
        transform="translate(0 -32.995)"
      />
      <path
        id="confirm_email_svg__Trazado_187"
        data-name="Trazado 187"
        className="confirm_email_svg__cls-1"
        d="M784.978 425.789h-15.227a12.982 12.982 0 01-12.951-12.951v-2.687a12.982 12.982 0 0112.951-12.951h15.228a12.982 12.982 0 0112.951 12.951v2.687a13.006 13.006 0 01-12.952 12.951z"
        transform="translate(-474.344 -232.874)"
      />
      <path
        id="confirm_email_svg__Trazado_188"
        data-name="Trazado 188"
        className="confirm_email_svg__cls-1"
        d="M328.292 101.112H296.12a94.078 94.078 0 00-152.126-58h-32.471a14.32 14.32 0 00-14.294 14.295 14.385 14.385 0 0011.906 14.108h23.14a15.642 15.642 0 0115.6 15.6v1.755a15.642 15.642 0 01-15.6 15.6H85.994A14.32 14.32 0 0071.7 118.765a14.32 14.32 0 0014.294 14.295h24.67a94.07 94.07 0 00150.633 57.1 13.932 13.932 0 003.77.522h36.427a14.32 14.32 0 0014.295-14.294 14.32 14.32 0 00-14.295-14.288H280a15.307 15.307 0 01-15.265-15.265v-2.015A15.307 15.307 0 01280 129.551h34.52a13.146 13.146 0 012.463.224h11.234a14.32 14.32 0 0014.294-14.294 14.248 14.248 0 00-14.219-14.369z"
        transform="translate(-44.94 2.229)"
      />
      <circle
        id="confirm_email_svg__Elipse_149"
        data-name="Elipse 149"
        className="confirm_email_svg__cls-2"
        cx={5.76}
        cy={5.76}
        transform="translate(75.878)"
        r={5.76}
      />
      <circle
        id="confirm_email_svg__Elipse_150"
        data-name="Elipse 150"
        className="confirm_email_svg__cls-2"
        cx={8.203}
        cy={8.203}
        transform="translate(215.681 8.378)"
        r={8.203}
      />
      <circle
        id="confirm_email_svg__Elipse_151"
        data-name="Elipse 151"
        className="confirm_email_svg__cls-2"
        cx={5.76}
        cy={5.76}
        transform="translate(253.25 83.995)"
        r={5.76}
      />
      <path
        id="confirm_email_svg__Trazado_189"
        data-name="Trazado 189"
        className="confirm_email_svg__cls-3"
        d="M680.462 93.021h-8.9v-8.9a1.92 1.92 0 10-3.84 0v8.9h-8.9a1.92 1.92 0 000 3.84h8.9v8.9a1.92 1.92 0 003.84 0v-8.9h8.9a1.937 1.937 0 001.92-1.92 1.909 1.909 0 00-1.92-1.92z"
        transform="translate(-397.629 -47.555)"
      />
      <path
        id="confirm_email_svg__Trazado_190"
        data-name="Trazado 190"
        className="confirm_email_svg__cls-3"
        d="M228.206 206.621h-8.9v-8.9a1.92 1.92 0 10-3.84 0v8.9h-8.946a1.92 1.92 0 100 3.84h8.9v8.9a1.92 1.92 0 103.84 0v-8.9h8.9a1.937 1.937 0 001.92-1.92 1.872 1.872 0 00-1.874-1.92z"
        transform="translate(-142.685 -111.587)"
      />
      <path
        id="confirm_email_svg__Trazado_191"
        data-name="Trazado 191"
        className="confirm_email_svg__cls-3"
        d="M730.913 258.919l-4.887-4.887 4.887-4.887a1.481 1.481 0 00-2.095-2.094l-4.887 4.887-4.887-4.887a1.481 1.481 0 00-2.094 2.094l4.887 4.887-4.887 4.887a1.481 1.481 0 002.094 2.094l4.887-4.887 4.887 4.887a1.5 1.5 0 002.095 0 1.426 1.426 0 000-2.094z"
        transform="translate(-431.237 -140.235)"
      />
      <g
        id="confirm_email_svg__Grupo_230"
        data-name="Grupo 230"
        transform="translate(100.385 162.374)"
      >
        <g id="confirm_email_svg__Grupo_229" data-name="Grupo 229">
          <path
            id="confirm_email_svg__Trazado_195"
            data-name="Trazado 195"
            className="confirm_email_svg__cls-3"
            d="M305.747 379.739h111.941c2.8 0 2.8-4.339 0-4.339H305.747c-2.8 0-2.8 4.339 0 4.339z"
            transform="translate(-303.65 -375.4)"
          />
        </g>
      </g>
      <g
        id="confirm_email_svg__Grupo_232"
        data-name="Grupo 232"
        transform="translate(226.789 162.374)"
      >
        <g id="confirm_email_svg__Grupo_231" data-name="Grupo 231">
          <path
            id="confirm_email_svg__Trazado_196"
            data-name="Trazado 196"
            className="confirm_email_svg__cls-3"
            d="M567.947 379.739h7.953c2.8 0 2.8-4.339 0-4.339h-7.954c-2.8 0-2.8 4.339 0 4.339z"
            transform="translate(-565.85 -375.4)"
          />
        </g>
      </g>
      <g
        id="confirm_email_svg__Grupo_234"
        data-name="Grupo 234"
        transform="translate(61.915 162.374)"
      >
        <g id="confirm_email_svg__Grupo_233" data-name="Grupo 233">
          <path
            id="confirm_email_svg__Trazado_197"
            data-name="Trazado 197"
            className="confirm_email_svg__cls-3"
            d="M225.947 379.739h24.972c2.8 0 2.8-4.339 0-4.339h-24.972c-2.8 0-2.8 4.339 0 4.339z"
            transform="translate(-223.85 -375.4)"
          />
        </g>
      </g>
      <g
        id="confirm_email_svg__Grupo_236"
        data-name="Grupo 236"
        transform="translate(110.763 73.032)"
      >
        <g id="confirm_email_svg__Grupo_40" data-name="Grupo 40">
          <g id="confirm_email_svg__Grupo_39" data-name="Grupo 39">
            <path
              id="confirm_email_svg__Trazado_8"
              data-name="Trazado 8"
              className="confirm_email_svg__cls-4"
              d="M88.566 59.733H4.661A4.661 4.661 0 000 64.394v62.152a4.661 4.661 0 004.661 4.661h83.9a4.661 4.661 0 004.661-4.661V64.394a4.661 4.661 0 00-4.656-4.661zm1.554 66.813a1.554 1.554 0 01-1.554 1.554H4.661a1.554 1.554 0 01-1.554-1.554V64.394a1.554 1.554 0 011.554-1.554h83.9a1.554 1.554 0 011.554 1.554v62.152z"
              transform="translate(0 -59.733)"
            />
            <path
              id="confirm_email_svg__Trazado_9"
              data-name="Trazado 9"
              className="confirm_email_svg__cls-4"
              d="M114.488 93.871a1.68 1.68 0 00-1.148.329l-36.287 27.7a3.391 3.391 0 01-4.049 0L36.717 94.2a1.7 1.7 0 00-1.549-.249 1.474 1.474 0 00-1.011 1.1 1.361 1.361 0 00.538 1.344l36.287 27.7a6.773 6.773 0 008.094 0l36.287-27.7a1.393 1.393 0 00.556-.971 1.344 1.344 0 00-.362-1.043 1.626 1.626 0 00-1.069-.51z"
              transform="translate(-28.415 -88.147)"
            />
            <path
              id="confirm_email_svg__Trazado_10"
              data-name="Trazado 10"
              className="confirm_email_svg__cls-4"
              d="M55.8 272.959a1.43 1.43 0 00-1.379.444l-20.014 21.443a1.429 1.429 0 102.09 1.95l20.013-21.443a1.429 1.429 0 00-.711-2.394z"
              transform="translate(-28.304 -231.493)"
            />
            <path
              id="confirm_email_svg__Trazado_11"
              data-name="Trazado 11"
              className="confirm_email_svg__cls-4"
              d="M343.7 273.4a1.43 1.43 0 10-2.09 1.95l20.01 21.45a1.43 1.43 0 002.09-1.95z"
              transform="translate(-276.586 -231.493)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgConfirmEmail;
